"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("./constants");

function isClockSkewError(error) {
  return error.name in constants_1.CLOCK_SKEW_ERROR_CODES;
}

exports.isClockSkewError = isClockSkewError;

function isStillProcessingError(error) {
  return error.name in constants_1.STILL_PROCESSING_ERROR_CODES;
}

exports.isStillProcessingError = isStillProcessingError;

function isThrottlingError(error) {
  return error.name in constants_1.THROTTLING_ERROR_CODES;
}

exports.isThrottlingError = isThrottlingError;